import { Button } from '@frontend/shadcn/components/ui/button';
import { ArrowsRotateIcon } from '@revfluence/fresh-icons/solid/esm';
import React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';

interface RefreshButtonProps {
  onRefresh: () => void;
  isRefreshing: boolean;
  className?: string;
}

export const RefreshButton = ({
  onRefresh,
  isRefreshing,
  className,
}: RefreshButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onRefresh}
      disabled={isRefreshing}
      className={cn('rounded-full', className)}
      aria-label="Refresh content"
      tooltip="Refresh content"
    >
      <ArrowsRotateIcon
        fontSize={14}
        className={cn(
          'text-muted-foreground',
          isRefreshing && 'animate-spin'
        )}
      />
    </Button>
  );
};
